import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  formatDate,
  formatPhoneNumber,
  formatTime,
  getIsMHCName,
} from "../../../../../utilities/utils";
import Loader from "../../../../commons/Loader";
import Pagination from "../../../pagination";
import { tableMenuMatchedItems } from "../../adminData";
import GlobalTableDropDown from "../../GlobalTableDropDown";
import { Link } from "react-router-dom";
import {
  VideoCameraIcon
 } from "@heroicons/react/24/outline";
import SpecificLoader from "../../../../commons/SpecificLoader";
import SkeletonTable from "../../../../commons/Skeleton/SkeletonTable"

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const AllMAtchesTable = ({
  matchesData,
  getUpdateData,
  handleDropDownMenu,
}) => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(null);

  const { data, meta } = matchesData ?? {};
  const { current_page, last_page, per_page } = meta ?? {};

  useEffect(() => {
    window.addEventListener("click", handleWindowClick);
    return () => {
      window.removeEventListener("click", handleWindowClick);
    };
  }, []);

  const handleMatchesNavigation = (match) => {
    navigate(`/admin-dashboard/matches/${match?.id}`, {
      state: {
        matchInfo: match,
      },
    });
  };

  const handleWindowClick = () => {
    setShowMenu(null);
  };

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const getMatchedProfession = (match) => {
    let name = "--";
    if (match) {
      let foundProfession = match?.user?.professions.find(
        (profession) =>
          match?.lead?.profession?.id == profession?.id ||
          match?.lead?.profession?.parent_id == profession?.id
      );
      if (foundProfession) {
        if (
          foundProfession?.name === "mental health counselor" ||
          foundProfession?.name === "Mental Health Counselor"
        ) {
          name = getIsMHCName(foundProfession);
        } else {
          name = foundProfession?.name;
        }
      }
    }
    return name;
  };

  return (
    <>
      <div className="px-4 sm:px-6 lg:px-8 hidden md:block relative">
         { (!matchesData || !matchesData?.data)?<SkeletonTable/>:<div className="mt-8 flow-root">
            <div className="table-scroller -mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white border border-[#EBEFF3] rounded-md p-5">
              <div className="inline-block min-w-full py-2 align-middle">
                <div className="relative">
                  <table className="min-w-full table-fixed divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Lead Name
                        </th>
                        <th
                          scope="col"
                          className="py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                        >
                          Matched Profession
                        </th>
                        <th
                          scope="col"
                          className="py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                        >
                          Professional Name
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Phone Number
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Credits
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Lead Email
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Location
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Created at
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {matchesData &&
                        matchesData?.data?.map((match, index) => (
                          <tr className="cursor-pointer hover:bg-[#EBF7FF]">
                            <Link
                              to={`/admin-dashboard/matches/${match?.id}`}
                              state={{ matchInfo: match }}
                              className="contents"
                            >
                                  <td className="whitespace-nowrap py-4 pr-3 text-sm font-normal flex text-customGray align-center">
                                {match?.lead?.first_name.concat(
                                  " ",
                                  match?.lead?.last_name
                                )}
                                {match.is_virtual_match ?
                                 <VideoCameraIcon  className="w-5 h-5 text-primary ml-2"/> : null}
                              </td>
                              <td className="whitespace-nowrap pr-3 py-4 text-sm text-customGray">
                                <span
                                  className="px-2.5 py-1 rounded-md text-white font-normal inline-flex justify-center items-center"
                                  style={{
                                    backgroundColor: `${
                                      match?.active ? "#16ca7c" : "#BEC2C5"
                                    }`,
                                    color: `${
                                      match?.active ? "white" : "#1c1c1c"
                                    }`,
                                  }}
                                >
                                  {match?.active ? "Active" : "Returned"}
                                </span>
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {getMatchedProfession(match)}
                              </td>

                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {match?.user?.first_name.concat(
                                  " ",
                                  match?.user?.last_name
                                )}
                              </td>

                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {formatPhoneNumber(match?.lead?.phone_number)}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {match.credit_cost}
                              </td>

                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {match?.lead?.email}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {match?.lead?.city?.concat(
                                  ", ",
                                  match?.lead?.county
                                )}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                                {formatDate(match?.created_at)} &#8226;{" "}
                                {formatTime(match?.created_at)}
                              </td>
                              <td>
                                <GlobalTableDropDown
                                  data={match}
                                  showMenu={showMenu === match.id}
                                  callBack={handleMenuItems}
                                  isLastIndex={index == data.length - 2}
                                  menuItems={tableMenuMatchedItems}
                                  setShowMenu={setShowMenu}
                                  handleDropDownMenu={handleDropDownMenu}
                                />
                              </td>
                            </Link>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {data?.length < 1 && (
                    <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
                      No Record Found.
                    </h4>
                  )}
                </div>
              </div>
            </div>
          </div>}

      </div>
        <div className="block md:hidden">
         {(!matchesData || !matchesData?.data)?<SkeletonTable />: <div>
            <ul>
              {data &&
                data?.slice(0, 5)?.map((match, index) => (
                  <li className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]">
                    <ul key={`${match}-table-${index}`} onClick={() => handleMatchesNavigation(match)}>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Lead Name
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {match?.lead?.first_name.concat(
                            " ",
                            match?.lead?.last_name
                          )}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Matched Profession
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {getMatchedProfession(match)}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Professional Name
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {match?.user?.first_name.concat(
                            " ",
                            match?.user?.last_name
                          )}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Phone Number
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {formatPhoneNumber(match?.lead?.phone_number)}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Created at
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {formatDate(match?.created_at)} &#8226;{" "}
                          {formatTime(match?.created_at)}
                        </span>
                      </li>
                    </ul>
                    <div>
                      <GlobalTableDropDown
                        data={match}
                        showMenu={showMenu === match?.id}
                        callBack={handleMenuItems}
                        isLastIndex={index == data?.length - 2}
                        menuItems={tableMenuMatchedItems}
                        setShowMenu={setShowMenu}
                        handleDropDownMenu={handleDropDownMenu}
                      />
                    </div>
                  </li>
                ))}
            </ul>
            {data?.length < 1 && (
              <div className=" bg-white border border-[#EBEFF3] rounded-md p-5">
                <h4 className="flex items-center justify-center mt-5 text-lg bg-white text-primary py-6 font-bold">
                  No Record Found.
                </h4>
              </div>
            )}
          </div>}
        </div>
      {data?.length > 0 && (
        <Pagination
          currentPage={current_page}
          totalPages={last_page}
          nextPage={getUpdateData}
          previousPage={getUpdateData}
          directIntoPage={getUpdateData}
          perPageItem={per_page}
          showNumberOfPages={3}
          meta={meta}
        />
      )}
    </>
  );
};

export default AllMAtchesTable;
